const ConfigFile =
  // there is a separate config file for extra credit processes
  {
    general: {siteURL: "", eventTracker: false, loggingMax: 1, demoAccount: "13571357" },
    activities: {levelMoodBoost: 50, levelCashBoost: 100},
    collegeItems: {collegeInterest: .035, collegeLoanTerm: 10, collegeCostPerYear: 12000},
    carItems: {carInterest: .07, carLoanTerm: 6, commuteYearlyMiles: 8320, weekendYearlyMiles: 4680, 
      gasCostPerGallon: 3.20, carLoanProcessFee: .10, carChangeLockedMonths: 3, 
      featureCheck: ["bicycleCost"]},
    gameBoard: {nbrMonthsNegative: 3, nbrMonthsMoodNegative: 3, baseLineExpenses: 500, 
        retirementBase: 500, moodPointMultiplier: 100, maxBadges: 8, retirementSalaryMultiplier: 10,
        retirementMinAmt: 1000000, backEndLogArr: ["student8", "Cheryl2", "student2"]},
    gameBoardLoans: {intRate: .10, loanTerm: 6, pctDownPayment: .20, depreciationPct: .10 },
    gameChoice: {carChangeMood: 1000, homeChangeMood: 3000, roommateChangeMood: 1000, jobChangeMood: 2000,
      carFloorValue: 500
    },
    gameStartItems: {totalNbrGameMonths: 360, monthlyMiscCost: 380, startingMoodPoints: 10000, 
        maxMoodPoints: 50000, enableUnlockedTemplate: true, phoneExpAmt: 65, busPassAmt: 88,
        bicycleCost: 760, walkingShoes: 80},  
    homeItems: {kitchenCost: 300, miscSupplies: 150, homeChangeLockedMonths: 3, mortgageInterest: .065,
        minHomeCost: 300000, PMIRate10Pct: .75, PMIRate5Pct: 1.20,
        mortgageLoanTerm: 30, downPayMinPct: .05, baseRentAmt: 1500.00, baseMovingCost: 500.00, 
        costPerBedroom: 75.00},
    insurance: {healthInsEmployeePct: .30, healthInsAmt: 370, rentersInsAmt: 30, carInsAmt: 75},
    investments: {bondFaceValue: 1000, historyYears: 7, taxThreshold: 100},
    savings: {savings401KOverdraftFee: 20, historyYears: 5},
    unlockedFeatures: {creditCardInterest: .20, creditCardMinimumPayPct: .02, 
      periodsCreditHistory: 6, creditCardLateFee: 30},
    login: {accountServiceID: "service_r04q4fv", accountPublicID: "pVtw3upqYGQ8-9iWu", 
        accountTemplate: "template_l0g2th8", passwordTemplate: "template_ve4uap8",
        contactPublicID: "Llk4rHviqfGTX9fMp", contactServiceID: "service_d9kblbo", contactTemplate: "template_6uj2w2c"  }, 
  
    };

export default ConfigFile